import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";
import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

export const useJoinBookingAction = (bookingId: string) => {
  const [joinBooking, isJoining] = useMutationWithError(joinBookingMutation);
  const { showToast } = useToast();

  const onSuccess = () => {
    showToast({
      description: t`You have successfully joined the booking!`,
      semanticStyle: "success",
      toastId: "join-booking-success",
    });
  };

  const handleJoinBooking = () => {
    joinBooking({
      variables: { input: { bookingId } },
      onCompleted: (res: {
        responsePayload?: { success?: boolean } | null;
      }) => {
        if (res?.responsePayload?.success) {
          onSuccess();
        }
      },
      onCompletedErrorCustom: () => {
        showToast({
          description: t`Sorry. An error occurred while joining that booking.`,
          semanticStyle: "error",
          toastId: "join-booking-error",
        });
        return [];
      },
    });
  };

  return { joinBooking: handleJoinBooking, isJoining } as const;
};

const joinBookingMutation = graphql`
  mutation useJoinBookingActionMutation($input: JoinBookingInput!) {
    responsePayload: joinBooking(input: $input) {
      errors {
        field
        code
        message
      }
      success
      booking {
        id
        canUpdate
        writeAccess
        rounds {
          edges {
            node {
              id
              __typename
              player {
                id
                fullName
                firstName
                lastName
                profileImage {
                  # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
                  publicId: renderingKey
                }
              }
              transportationType {
                id
                code
                customCode
                name
              }
              courseLayout {
                holeCount
              }
              ... on MemberRound {
                nonPlayingHost
                paymentStatus
              }
              ... on GuestRound {
                paymentStatus
              }
            }
          }
        }
      }
    }
  }
`;
